/* global DISPLAY_DATE_FORMAT */

import PropTypes from 'prop-types'
import React from 'react'
import Rodal from 'rodal'

import notifications, { toastSuccess } from '../../../../global/notifications'
import 'rodal/lib/rodal.css'
import './styles.css'

function RetentionDialog({
  isMobile,
  cancel,
  subscription,
  open,
  onClose,
  acceptRetentionDiscount,
  isDisabled
}) {
  const onCloseDialog = () => {
    onClose()
  }

  const isDiscountOffer =
    subscription?.cancellationDiscountEligible &&
    subscription?.cancellationDiscountPercentage > 0

  return (
    <Rodal
      visible={open}
      onClose={onCloseDialog}
      width={isMobile ? 335 : 600}
      height={330}
      animation="fade"
      className="confirmation"
    >
      <div className="subscription-section confirmation" id="RetentionDialog">
        <div className="header">
          <h2>
            {isDiscountOffer
              ? 'Before you go...'
              : "Don't forget\u2026"}
          </h2>
        </div>
        {isDiscountOffer ? (
          <>
            <div className="dialog-content">
              <p>
                Get {subscription?.cancellationDiscountPercentage}% off your
                current plan! No changes. No interruptions. Keep creating!
              </p>
            </div>
            <div className="action-buttons">
              <button
                type="button"
                onClick={() => {
                  acceptRetentionDiscount()
                }}
                className="btn -mini -orange"
                disabled={isDisabled}
              >
                {`Stay Subscribed & Save ${subscription?.cancellationDiscountPercentage}%`}
              </button>
              <button
                onClick={() => {
                  cancel()
                  onClose()
                }}
                className="cancel-anyway-btn"
                type="button"
                disabled={isDisabled}
              >
                Continue to cancel
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="dialog-content">
              <p className="discount-highlight">
                {`You're currently saving ${subscription?.discountPercentage}% on your subscription.`}
              </p>
              <p>
                {
                  "If you cancel, this rate ends. Future promotions may vary, and getting this discount again isn't guaranteed."
                }
              </p>
            </div>
            <div className="action-buttons">
              <button
                type="button"
                onClick={() => {
                  toastSuccess(notifications.keepDiscountSavings)
                  onCloseDialog()
                }}
                className="btn -mini -orange"
                disabled={isDisabled}
              >
                {`Keep My ${subscription?.discountPercentage}% Savings`}
              </button>
              <button
                onClick={() => {
                  cancel()
                  onClose()
                }}
                className="cancel-anyway-btn"
                type="button"
                disabled={isDisabled}
              >
                Cancel Anyway
              </button>
            </div>
          </>
        )}
      </div>
    </Rodal>
  )
}

RetentionDialog.propTypes = {
  isMobile: PropTypes.bool.isRequired
}

export default RetentionDialog
